import React from 'react';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import useLanguageCode from 'hooks/useLanguageCode';
import { FormattedMessage } from 'react-intl';
import Expandable from '../../../shared/Expandable';
import * as styles from './styles/styles.module.scss';

const {
  GIFT_FLOW: {
    FAQ: {
      HOW_DO_I_REDEEM,
      HOW_DO_I_REDEEM_ANSWER,
      CAN_I_GIVE_A_SUBSCRIPTION,
      CAN_I_GIVE_A_SUBSCRIPTION_ANSWER,
      WILL_I_KNOW,
      WILL_I_KNOW_ANSWER,
      WAS_NOT_RECIEVED,
      WAS_NOT_RECIEVED_ANSWER,
      IS_THERE_AN_EXPIRATION,
      IS_THERE_AN_EXPIRATION_ANSWER,
      CAN_I_BUY_A_PHYSICAL_GIFT_CARD,
      CAN_I_BUY_A_PHYSICAL_GIFT_CARD_ANSWER,
      FREQUENTLY_ASKED_QUESTIONS
    }
  }
} = StringConstantsMixin.strings;

const FrequentlyAskedQuestions = () => {
  const languageCode = useLanguageCode();

  return (
    <section className={styles.container}>
      <h3 className={styles.header}>{FREQUENTLY_ASKED_QUESTIONS}</h3>
      <Expandable title={HOW_DO_I_REDEEM} classes={styles.expandable}>
        <div className={styles.dropdownText}>{HOW_DO_I_REDEEM_ANSWER}</div>
      </Expandable>
      <Expandable title={CAN_I_GIVE_A_SUBSCRIPTION} classes={styles.expandable}>
        <div className={styles.dropdownText}>{CAN_I_GIVE_A_SUBSCRIPTION_ANSWER}</div>
      </Expandable>
      <Expandable title={WILL_I_KNOW} classes={styles.expandable}>
        <div className={styles.dropdownText}>{WILL_I_KNOW_ANSWER}</div>
      </Expandable>
      <Expandable title={WAS_NOT_RECIEVED} classes={styles.expandable}>
        <div className={styles.dropdownText}>
          <FormattedMessage
            defaultMessage="We can help! Please send your order confirmation number to <a>support@alltrails.com</a> and our customer support team will get to the bottom of it."
            values={{
              a: (chunks: string) => <a href={`mailto:${chunks}`}>{chunks}</a>
            }}
          />
        </div>
      </Expandable>
      <Expandable title={IS_THERE_AN_EXPIRATION} classes={styles.expandable}>
        <div className={styles.dropdownText}>{IS_THERE_AN_EXPIRATION_ANSWER}</div>
      </Expandable>
      <Expandable title={CAN_I_BUY_A_PHYSICAL_GIFT_CARD} classes={`${styles.expandable} ${styles.noBottomBorder}`}>
        <div className={styles.dropdownText}>{CAN_I_BUY_A_PHYSICAL_GIFT_CARD_ANSWER}</div>
      </Expandable>
      <div className={styles.needHelp}>
        <FormattedMessage
          defaultMessage="Need help? Ask at <a>support@alltrails.com</a>"
          values={{
            a: (chunks: string) => <a href={`mailto:${chunks}`}>{chunks}</a>
          }}
        />
        <br />
        <FormattedMessage
          defaultMessage="or visit our <a>Help Center</a>"
          values={{ a: (chunks: string) => <a href={`https://support.alltrails.com/hc/${languageCode}`}>{chunks}</a> }}
        />
      </div>
    </section>
  );
};

export default FrequentlyAskedQuestions;
